import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AvailabilityWidget from '../../components/availability-widget';

import SideBar from './sidebar';
import RadioGroup from './radioGroup';
import CheckBoxGroup from './checkboxGroup';
import Summary from './summary';

import * as SimplyBookService from '../../services/simplyBookService';
import * as SimplybookActions from '../../store/actions/simplyBook.actions';
import * as PriceConfig from '../../config/options';

class ReservationForm extends Component {
    constructor(props){
        super(props);

        this.chosenOptions = {};

        this.state = {
            currentStep: 2,
            basePrice: 0,
            selectedOptions: [],
            boothInfo: {},
            optionProps: null,
            userAddress: null,
            contactInfo: {}
        };
    }

    componentWillMount(){
        this.setSideBar(this.props);
    }

    componentWillReceiveProps(nextProps){
        this.setSideBar(nextProps)
    }

    /**
     * This method will set the necessary information for the sidebar
     */
    setSideBar(props){
        if(
            props.simplyBook.newEvent &&
            props.simplyBook.newEvent.event &&
            props.simplyBook.newEvent.event.eventId
        ){
            this.setState({
                boothInfo: props.simplyBook.events[props.simplyBook.newEvent.event.eventId],
                basePrice: PriceConfig.boothPricing[props.simplyBook.newEvent.event.eventId]
            });
        }
    }

    /**
     * This method will handle all the radio button options
     * @param item
     * @param groupName
     */
    handleRadioGroup(item, groupName){
        if(!this.chosenOptions[groupName]){
            this.chosenOptions[groupName] = item;
            this.setState({
                selectedOptions: [...this.state.selectedOptions, ...item]
            })
        }else{
            let previousOption = this.chosenOptions[groupName];
            let clearedList = this.state.selectedOptions.filter((obj) => {
                return obj.title !== previousOption.title
            });
            this.setState({
                selectedOptions: [...clearedList, ...item]
            });
            // Set new group name option
            this.chosenOptions[groupName] = item;
        }
    }

    handleCheckBoxGroup(checkbox, item){
        if(checkbox.target.checked){
            this.setState({
                selectedOptions: [...this.state.selectedOptions, item]
            })
        }else{
            let clearedList = this.state.selectedOptions.filter((obj) => {
                return obj.title !== item.title
            });
            this.setState({
                selectedOptions: clearedList
            })
        }
    }

    submitRequest(event){
        event.preventDefault();

        const totalPrice = this.state.selectedOptions.reduce((total, item) => {
            return total + item.price;
        }, this.state.basePrice);

        const optionList = this.state.selectedOptions.map((item) => {
            return item.title;
        }).join(", ");


        const reservation = {
            "eventId": this.props.simplyBook.newEvent.event.eventId,
            // Select the first unit from the availability list
            "unitId": this.props.simplyBook.newEvent.availability[0],
            "date": this.props.simplyBook.newEvent.event.eventDate,
            "time": "12:00",
            "boothName": this.state.boothInfo.name,
            "customerName": this.refs.firstName.value + ' ' + this.refs.lastName.value,
            "customerEmail": this.refs.emailAdress.value,
            "customerPhone": this.refs.phoneNumber.value,
            "customerAddress": this.refs.streetName.value + ' ' + this.refs.houseNumber.value,
            "customerCity": this.refs.city.value,
            "customerZip": this.refs.postalCode.value,
            "companyName": this.refs.companyName.value,
            "eventCity": this.refs.eventCity.value,
            "eventLocation": this.refs.eventLocation.value,
            "eventPostalCode": this.refs.eventPostalCode.value,
            "eventStreet": this.refs.eventStreet.value +' '+ this.refs.eventHouseNumber.value,
            "eventType": this.refs.eventType.value,
            "message": this.refs.message.value,
            "options": optionList,
            "pricing": totalPrice
        };

        this.setState({
            makingReservation: true
        });

        SimplyBookService.makeBooking(reservation)
            .then(() => {
                this.setState({
                    makingReservation: false,
                    finishedBooking: true
                })
            })
            .catch(() => {
                this.setState({
                    makingReservation: false
                })
            });
    }

    renderOptionsBlock(){
        return (
            <div className="columns is-multiline">
                <div className="column is-full">
                    <h4 className="step--active">Stap 2: Selecteer de gewenste opties</h4>
                </div>
                <div className="column is-full">
                    <p>
                        <strong>Selecteer een props pakket</strong>
                        <br/>
                        Snorretjes, duimpje omhoog en brilletjes. Een kleine greep uit het assortiment aan photo props. Standaard krijg je van ons een setje met
                        standaard props die het goed doen op elk feestje. Wil je props voor een baby shower, kerst of oud en nieuw? Kies dan voor thema props.

                    </p>
                    <RadioGroup name='props' onChange={ this.handleRadioGroup.bind(this) } items={PriceConfig.orderOptions.props} />
                </div>
                <div className="column is-full">
                    <strong>Kies uit een frame</strong>
                    <br/>
                    <RadioGroup name='template' onChange={ this.handleRadioGroup.bind(this) } items={PriceConfig.orderOptions.templates } />
                </div>
                <div className="column is-full">
                    <strong>Kies een achtergrond</strong>
                    <br/>
                    <RadioGroup name='backdrops' onChange={ this.handleRadioGroup.bind(this) } items={PriceConfig.orderOptions.backDrops } />
                </div>
                <div className="column is-full">
                    <strong>Maak de booth compleet</strong>
                    <br/>
                    <CheckBoxGroup onChange={ this.handleCheckBoxGroup.bind(this) } items={PriceConfig.orderOptions.expansion } />
                </div>
            </div>
        )
    }

    renderContact(){
        return (
            <div className="columns">
                <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="content">
                                <h5>Contactgegevens</h5>
                            </div>
                            <div className="field">
                                <div className="field-body">
                                    <div className="field">
                                        <label className="label">Voornaam</label>
                                        <p className="control">
                                            <input className="input" type="text" placeholder="" ref="firstName" required />
                                        </p>
                                    </div>
                                    <div className="field">
                                        <label className="label">Achternaam</label>
                                        <p className="control">
                                            <input className="input " type="text" ref="lastName" required />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <lable className="label">Bedrijsnaam</lable>
                                <div className="control">
                                    <input type="text" className="input" placeholder="Indien van toepassing" ref="companyName"/>
                                </div>
                            </div>
                            <div className="field">
                                <div className="field-body">
                                    <div className="field">
                                        <label className="label">Straatnaam</label>
                                        <p className="control">
                                            <input className="input" type="text" placeholder="" ref="streetName" required />
                                        </p>
                                    </div>
                                    <div className="field">
                                        <label className="label">Huisnummer</label>
                                        <p className="control">
                                            <input className="input " type="number" ref="houseNumber" required />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <div className="field-body">
                                    <div className="field">
                                        <label className="label">Postcode</label>
                                        <p className="control">
                                            <input className="input" type="text" ref="postalCode" required />
                                        </p>
                                    </div>
                                    <div className="field">
                                        <label className="label">Woonplaats</label>
                                        <p className="control">
                                            <input className="input " type="text" ref="city" required />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <lable className="label">E-mail adres</lable>
                                <div className="control">
                                    <input type="email" className="input" ref="emailAdress" onChange={(evt) => { this.setState({userAddress: evt.target.value}) } } required />
                                </div>
                            </div>
                            <div className="field">
                                <lable className="label">Telefoonnummer</lable>
                                <div className="control">
                                    <input type="text" className="input" ref="phoneNumber" required/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column">
                    <div className="card">
                        <div className="card-content">
                            <div className="content">
                                <h5>Feestlocatie</h5>
                            </div>
                            <div className="field">
                                <label className="label">
                                    Soort feest / evenement
                                </label>
                                <div className="control">
                                    <div className="select">
                                        <select id="dropdown" ref="eventType">
                                            <option value="">Selecteer een soort</option>
                                            <option>Bruiloft</option>
                                            <option>Verjaardag / Jubileumfeest</option>
                                            <option>Beurs</option>
                                            <option>Personeelsfeest</option>
                                            <option>Evenement</option>
                                            <option>Open dag</option>
                                            <option>Anders</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <lable className="label">Locatie</lable>
                                <div className="control">
                                    <input type="text" className="input" placeholder="Bijvoorbeeld Partyboerderij Hijdra" ref="eventLocation" required/>
                                </div>
                            </div>
                            <div className="field">
                                <div className="field-body">
                                    <div className="field">
                                        <label className="label">Straatnaam</label>
                                        <p className="control">
                                            <input className="input" type="text" ref="eventStreet" required />
                                        </p>
                                    </div>
                                    <div className="field">
                                        <label className="label">Huisnummer</label>
                                        <p className="control">
                                            <input className="input " type="number" ref="eventHouseNumber" required />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <div className="field-body">
                                    <div className="field">
                                        <label className="label">Postcode</label>
                                        <p className="control">
                                            <input className="input" type="text" ref="eventPostalCode" required />
                                        </p>
                                    </div>
                                    <div className="field">
                                        <label className="label">Plaats</label>
                                        <p className="control">
                                            <input className="input " type="text" ref="eventCity" required />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">Opmerkingen</label>
                                <div className="control">
                                    <textarea className="textarea is-primary" type="text" ref="message" placeholder="Gebruik dit veld om bijzondere informatie te vermelden zoals locatie heeft alleen een trap, speciale wensen of bijvoorbeeld dat het een buiten locatie betreft" />
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">Hoe heb je ons gevonden</label>
                                <div className="control">
                                    <div className="select">
                                        <select name="referral" id="referral">
                                            <option value="">Kies een van de opties..</option>
                                            <option>Facebook</option>
                                            <option>Google</option>
                                            <option>Via vrienden of familie</option>
                                            <option>Anders</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderForm(){
        return (
            <div className="columns is-multiline">
                <div className="column">
                    <div className="content">
                        <form onSubmit={this.submitRequest.bind(this)}>
                            {

                                this.props.simplyBook.newEvent && this.props.simplyBook.newEvent.availability && this.props.simplyBook.newEvent.availability.length > 0 &&
                                <div className="notification is-primary">
                                    Goed nieuws! We hebben nog een Photobooth voor je beschikbaar!
                                </div>
                            }

                            {
                                this.renderOptionsBlock()
                            }

                            <h4 className="step--active">Stap 3: Voer de contactgegevens en feestlocatie in</h4>
                            {
                                this.renderContact()
                            }

                            <Summary
                                boothInfo={this.state.boothInfo}
                                event={this.props.simplyBook.newEvent.event}
                                selectedOptions={this.state.selectedOptions}
                                userAddress={this.state.userAddress}
                                basePrice={this.state.basePrice}
                            />

                            <button type="submit" className={`button is-primary  ${this.state.makingReservation ? 'is-loading' : ''}`}>
                                Plaats een reservering
                            </button>
                        </form>

                    </div>
                </div>

                <SideBar
                    boothInfo={this.state.boothInfo}
                    prices={{
                        basePrice: this.state.basePrice,
                        selectedOptions: this.state.selectedOptions
                    }}
                />
            </div>
        )
    }


    render(){
        if(this.state.finishedBooking){
            return (
                <div className="section">
                    <div className="container">
                        <div className="content">
                            <h4 className="step--active">Bedankt voor uw boeking!</h4>
                            <p>
                                U ontvangt binnen 24 uur een reserveringsbevestiging van ons. Mocht u aangegeven hebben dat u op maat gemaakte props, frames of achtergronden wenst dan zal onze ontwerper eveneens binnen 24 uur contact met u opnemen.
                            </p>
                            <p>
                                Heeft u in de tussentijd vragen of opmerkingen dan kunt u maandag tot en met zaterdag van 09:00 uur tot 21:00 uur contact met ons opnemen via telefoon of whatsapp: <strong><a href="https://api.whatsapp.com/send?phone=31644066185">+31 (0)6 - 440 661 85</a></strong>
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="section">
                <div className="container">
                    <div className="content">
                        <h4 className="step--active">Stap 1: Maak een keuze voor de photobooth en datum</h4>
                        <p>
                            We bieden momenteel twee photobooths aan. De Gifture Classic wordt standaard verhuurd zonder begeleiding maar is wel met begeleiding te boeken. De Gifture Event Booth wordt standaard verhuur met een enthousiaste medewerker!
                        </p>
                    </div>
                    <AvailabilityWidget reservation={true}/>
                    {
                        this.props.simplyBook.newEvent &&
                        this.props.simplyBook.newEvent.event &&
                        this.renderForm()
                    }

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        simplyBook: state.simplyBook
    }
};

const mapDispatchToProps = (dispatch) => ({
    simplybookActions: bindActionCreators(SimplybookActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReservationForm);



// WEBPACK FOOTER //
// ./src/components/reservationForm/index.js